module.exports = __webpack_public_path__ + "img/shuiyin.1ce88526.png";